<template>
  <div id="app">
    <!--<keep-alive>-->
    <router-view>
        
    </router-view>
    <!--</keep-alive>-->
  </div>
</template>

<script>
  export default {
    name: 'app',
//    created: function () {
    // appid 的缓存
//      this.$logger(this.$route.query.appid);
//      this.$logger('appvue created')
//      this.$store.dispatch('setAppId', this.$route.query.appid)
//    }
  }
</script>

<style>
  .youxiang{
    background-color: rgba(0,0,0,.5)!important;
  }
  .Partiallyproductlist,.ivu-table-header,.ivu-table th{
    background-color:#E6EFFA !important;
    font-weight: 100;
    /*color:#fff !important;*/
  }
  .ivu-table-row .ivu-table-column-center .ivu-table-cell{padding:5px !important;}
  .ifDengFen .ivu-table-cell span{
        color: red;
        font-size:14px;
        font-weight: 600;
      }

  /* td.ifDengFen.ivu-table-column-center, th.ifDengFen.ivu-table-column-center{
    border:1px solid #000;
  }
  td.processingWeight.ivu-table-column-center, th.processingWeight.ivu-table-column-center{
    border-right:1px solid #000;
  } */
  .ivu-table-column-center .ivu-table-cell{padding:0 !important;}
  .table_expand_th_padding .ivu-table-cell{
    padding: 0 !important;
  }
  .ivu-modal-mask{
      opacity:0;
  }
/*  .ivu-spin-main{
    z-index: -1 !important;
}*/
  .ivu-checkbox-checked .ivu-checkbox-inner::after{
content: '1' !important;
font-size:0;
}
.hand_move_maintenance_products td.ivu-table-expanded-cell{
  padding:30px 50px;
}
.subpage .titSecond .ivu-table{
    /*height: 300px;*/
    overflow-y: scroll !important;
}
.ivu-modal-wrap{
  z-index: 10000 !important;
}
.ladingsee ivu-scroll-container{
    overflow-y: scroll;
    height: 800px !important;
}
/*.ivu-scroll-container{
    height: 750px;
}*/
.ivu-scroll-loader{
  height: 0;
}
html{
  overflow-y: hidden;
}
.ivu-scroll-container {
  overflow-x:hidden;
}
.adddingdan{
  height: 600px;
  max-height:1000px;
  overflow-y: scroll;
}
#app{
  height: 100%;
}
body{
  height: 100%;
}
.ivu-scroll-content-loading{
  opacity: 1 !important;
}
/*    .ivu-spin-fix .ivu-spin-main{
        background-color:#f5f7f9 !important;
        left:50%;
        margin-left:450px;
    }*/
.ivu-spin-fix{
  background-color: #f5f7f9 !important;
}
 .ivu-spin-fix .ivu-spin-main{
        background-color:#f5f7f9 !important;

    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        background-color:#f5f7f9 !important;
        margin:0 auto;

        /*border: 1px solid #eee;*/
    }
    .ivu-scroll-loader-wrapper .ivu-scroll-spinner-icon{
      color: white !important;
    }
    .adddingdan   .wait_submit_car .ivu-table-body{
    height: 300px !important;
    overflow-y:scroll !important; 
    
  }
  .ivu-scroll-loader-text{
    color: white;
  }
   .deliveryDate .ivu-table-cell{
        text-align: left;
      }
   .deliveryPlaceCode .ivu-table-cell{
        text-align: left;
      }
/*.layout .ivu-modal-wrap{
  background-color:red !important;
  z-index: 10000 !important;
}*/
/*.ivu-table-tip td span{
  color: red;
}*/
/*.zhiliang layout-content-right {
  margin-top:90px !important;
}*/
/*  .Partiallyproductlist .chengpin .ivu-table-header, .ivu-table table th{
        background-color:blue !important;
        }
     .materiallist .yuanliao .ivu-table-header, .ivu-table table th{
    background-color:red !important;
    }*/
</style>



// WEBPACK FOOTER //
// App.vue?a5b2dc24